import {AssetPolicyPutDataTransferObjectDescription} from "../../../data/data-transfer-object-description/asset/AssetPolicyPutDataTransferObjectDescription"
import {AssetPolicyPutState} from "../../../data/data-transfer-object-state/asset/AssetPolicyPutState"
import {AssetPolicyPutDataTransferObject} from "../../../data/data-transfer-object/asset/AssetPolicyPutDataTransferObject"
import {PostBigIntField, PostBitMaskField, PostBooleanField, PostDateField, PostEnumField, PostFieldWrapper, PostInputField, PostNumberField, PostTextareaField} from "../../PostField"
import {RouterProps} from "../../RouterProps"
import {JSX} from "react"

type PostFieldProps = RouterProps & {
    state: AssetPolicyPutState
}

export const AssetPolicyPutField: Record<Capitalize<keyof AssetPolicyPutDataTransferObject>, (props: PostFieldProps) => JSX.Element> = {
    AssetCouponPageSize(props: PostFieldProps): JSX.Element {
        return (
            <PostFieldWrapper
                {...props}
                title={AssetPolicyPutDataTransferObjectDescription.assetCouponPageSize}>
                <PostNumberField
                    {...props}
                    value={props.state.assetCouponPageSize.value}
                    setter={props.state.assetCouponPageSize.setter} />
            </PostFieldWrapper>
        )
    },
    AssetCouponUsagePageSize(props: PostFieldProps): JSX.Element {
        return (
            <PostFieldWrapper
                {...props}
                title={AssetPolicyPutDataTransferObjectDescription.assetCouponUsagePageSize}>
                <PostNumberField
                    {...props}
                    value={props.state.assetCouponUsagePageSize.value}
                    setter={props.state.assetCouponUsagePageSize.setter} />
            </PostFieldWrapper>
        )
    },
    AssetLunarUsagePageSize(props: PostFieldProps): JSX.Element {
        return (
            <PostFieldWrapper
                {...props}
                title={AssetPolicyPutDataTransferObjectDescription.assetLunarUsagePageSize}>
                <PostNumberField
                    {...props}
                    value={props.state.assetLunarUsagePageSize.value}
                    setter={props.state.assetLunarUsagePageSize.setter} />
            </PostFieldWrapper>
        )
    },
    AssetLunarExchangeOptionPageSize(props: PostFieldProps): JSX.Element {
        return (
            <PostFieldWrapper
                {...props}
                title={AssetPolicyPutDataTransferObjectDescription.assetLunarExchangeOptionPageSize}>
                <PostNumberField
                    {...props}
                    value={props.state.assetLunarExchangeOptionPageSize.value}
                    setter={props.state.assetLunarExchangeOptionPageSize.setter} />
            </PostFieldWrapper>
        )
    },
    AssetLunarExchangeExp(props: PostFieldProps): JSX.Element {
        return (
            <PostFieldWrapper
                {...props}
                title={AssetPolicyPutDataTransferObjectDescription.assetLunarExchangeExp}>
                <PostNumberField
                    {...props}
                    value={props.state.assetLunarExchangeExp.value}
                    setter={props.state.assetLunarExchangeExp.setter} />
            </PostFieldWrapper>
        )
    },
    AssetLunarPurchaseOptionPageSize(props: PostFieldProps): JSX.Element {
        return (
            <PostFieldWrapper
                {...props}
                title={AssetPolicyPutDataTransferObjectDescription.assetLunarPurchaseOptionPageSize}>
                <PostNumberField
                    {...props}
                    value={props.state.assetLunarPurchaseOptionPageSize.value}
                    setter={props.state.assetLunarPurchaseOptionPageSize.setter} />
            </PostFieldWrapper>
        )
    },
    AssetLunarPurchaseExp(props: PostFieldProps): JSX.Element {
        return (
            <PostFieldWrapper
                {...props}
                title={AssetPolicyPutDataTransferObjectDescription.assetLunarPurchaseExp}>
                <PostNumberField
                    {...props}
                    value={props.state.assetLunarPurchaseExp.value}
                    setter={props.state.assetLunarPurchaseExp.setter} />
            </PostFieldWrapper>
        )
    },
    AssetPolicyPageSize(props: PostFieldProps): JSX.Element {
        return (
            <PostFieldWrapper
                {...props}
                title={AssetPolicyPutDataTransferObjectDescription.assetPolicyPageSize}>
                <PostNumberField
                    {...props}
                    value={props.state.assetPolicyPageSize.value}
                    setter={props.state.assetPolicyPageSize.setter} />
            </PostFieldWrapper>
        )
    },
    AssetSolarUsagePageSize(props: PostFieldProps): JSX.Element {
        return (
            <PostFieldWrapper
                {...props}
                title={AssetPolicyPutDataTransferObjectDescription.assetSolarUsagePageSize}>
                <PostNumberField
                    {...props}
                    value={props.state.assetSolarUsagePageSize.value}
                    setter={props.state.assetSolarUsagePageSize.setter} />
            </PostFieldWrapper>
        )
    },
    AssetSolarWithdrawalPageSize(props: PostFieldProps): JSX.Element {
        return (
            <PostFieldWrapper
                {...props}
                title={AssetPolicyPutDataTransferObjectDescription.assetSolarWithdrawalPageSize}>
                <PostNumberField
                    {...props}
                    value={props.state.assetSolarWithdrawalPageSize.value}
                    setter={props.state.assetSolarWithdrawalPageSize.setter} />
            </PostFieldWrapper>
        )
    },
    AssetSolarWithdrawalOptionPageSize(props: PostFieldProps): JSX.Element {
        return (
            <PostFieldWrapper
                {...props}
                title={AssetPolicyPutDataTransferObjectDescription.assetSolarWithdrawalOptionPageSize}>
                <PostNumberField
                    {...props}
                    value={props.state.assetSolarWithdrawalOptionPageSize.value}
                    setter={props.state.assetSolarWithdrawalOptionPageSize.setter} />
            </PostFieldWrapper>
        )
    },
    AssetSolarWithdrawalExp(props: PostFieldProps): JSX.Element {
        return (
            <PostFieldWrapper
                {...props}
                title={AssetPolicyPutDataTransferObjectDescription.assetSolarWithdrawalExp}>
                <PostNumberField
                    {...props}
                    value={props.state.assetSolarWithdrawalExp.value}
                    setter={props.state.assetSolarWithdrawalExp.setter} />
            </PostFieldWrapper>
        )
    },
    AssetStarChargePageSize(props: PostFieldProps): JSX.Element {
        return (
            <PostFieldWrapper
                {...props}
                title={AssetPolicyPutDataTransferObjectDescription.assetStarChargePageSize}>
                <PostNumberField
                    {...props}
                    value={props.state.assetStarChargePageSize.value}
                    setter={props.state.assetStarChargePageSize.setter} />
            </PostFieldWrapper>
        )
    },
    AssetStarUsagePageSize(props: PostFieldProps): JSX.Element {
        return (
            <PostFieldWrapper
                {...props}
                title={AssetPolicyPutDataTransferObjectDescription.assetStarUsagePageSize}>
                <PostNumberField
                    {...props}
                    value={props.state.assetStarUsagePageSize.value}
                    setter={props.state.assetStarUsagePageSize.setter} />
            </PostFieldWrapper>
        )
    },
    AssetStarUsageExp(props: PostFieldProps): JSX.Element {
        return (
            <PostFieldWrapper
                {...props}
                title={AssetPolicyPutDataTransferObjectDescription.assetStarUsageExp}>
                <PostNumberField
                    {...props}
                    value={props.state.assetStarUsageExp.value}
                    setter={props.state.assetStarUsageExp.setter} />
            </PostFieldWrapper>
        )
    },
    AssetStarExchangeOptionPageSize(props: PostFieldProps): JSX.Element {
        return (
            <PostFieldWrapper
                {...props}
                title={AssetPolicyPutDataTransferObjectDescription.assetStarExchangeOptionPageSize}>
                <PostNumberField
                    {...props}
                    value={props.state.assetStarExchangeOptionPageSize.value}
                    setter={props.state.assetStarExchangeOptionPageSize.setter} />
            </PostFieldWrapper>
        )
    },
    AssetStarExchangeExp(props: PostFieldProps): JSX.Element {
        return (
            <PostFieldWrapper
                {...props}
                title={AssetPolicyPutDataTransferObjectDescription.assetStarExchangeExp}>
                <PostNumberField
                    {...props}
                    value={props.state.assetStarExchangeExp.value}
                    setter={props.state.assetStarExchangeExp.setter} />
            </PostFieldWrapper>
        )
    },
    AssetStarChargeMinutes(props: PostFieldProps): JSX.Element {
        return (
            <PostFieldWrapper
                {...props}
                title={AssetPolicyPutDataTransferObjectDescription.assetStarChargeMinutes}>
                <PostNumberField
                    {...props}
                    value={props.state.assetStarChargeMinutes.value}
                    setter={props.state.assetStarChargeMinutes.setter} />
            </PostFieldWrapper>
        )
    },
    AssetStarChargeMax(props: PostFieldProps): JSX.Element {
        return (
            <PostFieldWrapper
                {...props}
                title={AssetPolicyPutDataTransferObjectDescription.assetStarChargeMax}>
                <PostNumberField
                    {...props}
                    value={props.state.assetStarChargeMax.value}
                    setter={props.state.assetStarChargeMax.setter} />
            </PostFieldWrapper>
        )
    },
}

export function AssetPolicyPutFields(props: PostFieldProps) {
    return <>
        <AssetPolicyPutField.AssetCouponPageSize
            {...props}
            state={props.state} />
        <AssetPolicyPutField.AssetCouponUsagePageSize
            {...props}
            state={props.state} />
        <AssetPolicyPutField.AssetLunarUsagePageSize
            {...props}
            state={props.state} />
        <AssetPolicyPutField.AssetLunarExchangeOptionPageSize
            {...props}
            state={props.state} />
        <AssetPolicyPutField.AssetLunarExchangeExp
            {...props}
            state={props.state} />
        <AssetPolicyPutField.AssetLunarPurchaseOptionPageSize
            {...props}
            state={props.state} />
        <AssetPolicyPutField.AssetLunarPurchaseExp
            {...props}
            state={props.state} />
        <AssetPolicyPutField.AssetPolicyPageSize
            {...props}
            state={props.state} />
        <AssetPolicyPutField.AssetSolarUsagePageSize
            {...props}
            state={props.state} />
        <AssetPolicyPutField.AssetSolarWithdrawalPageSize
            {...props}
            state={props.state} />
        <AssetPolicyPutField.AssetSolarWithdrawalOptionPageSize
            {...props}
            state={props.state} />
        <AssetPolicyPutField.AssetSolarWithdrawalExp
            {...props}
            state={props.state} />
        <AssetPolicyPutField.AssetStarChargePageSize
            {...props}
            state={props.state} />
        <AssetPolicyPutField.AssetStarUsagePageSize
            {...props}
            state={props.state} />
        <AssetPolicyPutField.AssetStarUsageExp
            {...props}
            state={props.state} />
        <AssetPolicyPutField.AssetStarExchangeOptionPageSize
            {...props}
            state={props.state} />
        <AssetPolicyPutField.AssetStarExchangeExp
            {...props}
            state={props.state} />
        <AssetPolicyPutField.AssetStarChargeMinutes
            {...props}
            state={props.state} />
        <AssetPolicyPutField.AssetStarChargeMax
            {...props}
            state={props.state} />
    </>
}
